import ConnectModal from 'web3modal';
import WalletConnectProvider from '@walletconnect/web3-provider';

export const Web3Modal = new ConnectModal({
  cacheProvider: true, // optional
  providerOptions: {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: process.env.REACT_APP_INFURA_ID,
      },
    },
  },
  // TODO: theme
});
